// ⚠️ Ce fichier est généré automatiquement depuis .env par scripts/set-env.js
// ⚠️ NE PAS MODIFIER MANUELLEMENT - vos changements seront écrasés
// ⚠️ Pour changer les valeurs, modifiez le fichier .env à la racine du projet

export const environment = {
  production: false,
  baseUrl: 'https://api.dev.v2.moon.community',
  cizoUrl: 'https://api.dev.tg.moon.community/api',
  KEYCLOAK_URL: 'https://login.moon.community/realms/moon-sandbox',
  KEYCLOAK_REALM: 'moon-sandbox',
  KEYCLOAK_CLIENTID: 'moon-togo-web-app',
  REDIRECT_URL: 'https://moon-io-web.dev.v2.moon.community',
  MAPS_URL: 'https://maps.v2.moon.community/maps/',
  WEBAPP_URL: 'https://webapp.dev.v2.moon.community',
  token: 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJuYmYiOjE3NDY3MTQwMzAsImlzcyI6Im1vb24tdG9nby1hcGkiLCJhdWQiOiJtb29uLXRvZ28tYXBpIiwiaWF0IjoxNzQ2NzE0MDMwLCJ0b2tlbl9pZCI6NCwicGVybWlzc2lvbnMiOlsiQVBJX0NIRUNLX0NJWk9fUEhPTkVfTlVNQkVSUyIsIkFQSV9DSEVDS19DSVpPX1JFR0lTVFJBVElPTiJdfQ.AQmzPyG-snj_2vqc2tFodX4F8rY036XXunwXMjNJA-A',
  MATOMO_URL_BASE: 'https://nltcs.moon.community/',
  MATOMO_SITE_ID: '9',
  version: '2.9.0',
};
